function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".a{fill:#b9b9b9;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.18 13.18) rotate(180)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M13.024.156a.532.532,0,0,0-.753,0L.156,12.271a.532.532,0,1,0,.753.753L13.024.909A.532.532,0,0,0,13.024.156Z",
  transform: "translate(0 0)"
})), React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M13.024,12.272.909.157A.532.532,0,0,0,.156.91L12.271,13.025a.532.532,0,1,0,.753-.753Z",
  transform: "translate(0 -0.001)"
}))));
var SvgCloseBuilder = function SvgCloseBuilder(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 13.18,
    height: 13.18,
    viewBox: "0 0 13.18 13.18",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseBuilder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-builder.e0179283.svg";
export { ForwardRef as ReactComponent };